import React, {useState} from 'react'
import 'css/index.scss'
import {Col, Row} from 'components/Display'

import i18n from 'i18n'
import ProjectContext from 'views/hoc/ProjectContext'
import requiresLoggedIn from 'views/hoc/loggedIn'
import services from 'services'
import extensionLogo from 'assets/extension-logo.svg'
import extensionAddProblemGray from 'assets/extension-add-problem-gray.svg'
import extensionAddProblemBlue from 'assets/extension-add-problem-blue.svg'
import AuthService from 'services/AuthService'
import config from 'config'

function App() {
  const service = services.getChromePopupService()
  const [activateAddProblem, setActivateAddProblem] = useState(false)

  const authService = services.getAuthService()
  const [user] = authService.user.hook()

  return (
    <ProjectContext>
      {(context) => {
        return (
          <Col className="h-full w-full rounded shadow-2xl bg-white">
            <img className={`w-5/12 mx-6 pt-2 pb-2`} alt={'extensionLogo'} src={extensionLogo} />
            <div>
              <Row className="p-4">
                {/* {context.project != null && <div className="ml-2 mt-2">{i18n.t('chrome.selectedProject')}</div>} */}
                <ProjectContext.Selector
                  className="w-full text-itx-greyscale-2 font-semibold px-2 pt-2 pb-2 mx-2 border rounded-md"
                  context={context}
                />
              </Row>
            </div>
            <Col
              className={`pt-2 pb-2 mx-6 mt-4 mb-4 cursor-pointer z-50 ${
                activateAddProblem === false ? 'bg-gray-itx-light border-b-2 border-transparent' : 'bg-blue-itx-light border-b-2 border-itx-primary-4'
              }`}
              onClick={() => {
                setActivateAddProblem(!activateAddProblem)
                service.requestor.exec('contentApp', 'mount', {
                  authToken: AuthService.getAuthToken(),
                  project: context.project,
                })
              }}
            >
              {activateAddProblem === false ? (
                <img alt={'extensionAddProblemGray'} src={extensionAddProblemGray} />
              ) : (
                <img alt={'extensionAddProblemBlue'} src={extensionAddProblemBlue} />
              )}
              <button className={`${activateAddProblem === false ? 'text-black font-semibold' : 'text-itx-primary-4 font-semibold'}`}>
                {i18n.t('chrome.addProblem')}
              </button>
            </Col>
            {context.project === null && (
              <Col className="flex-1 items-center justify-center">
                <div>{i18n.t('chrome.selectAProject')}</div>
              </Col>
            )}
            <a
              className="font-semibold text-xs text-itx-greyscale-2 rounded border pl-2 pr-2 pt-2 pb-2 mx-6 text-center"
              href={`${config.appUrl}/projects/${context.project?.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Project
            </a>
            {user != null && (
              <Row className="justify-center mt-4">
                <div className="text-itx-primary-4 font-medium cursor-pointer" onClick={() => AuthService.logOut()}>
                  Logout
                </div>
              </Row>
            )}
          </Col>
        )
      }}
    </ProjectContext>
  )
}

const Content = requiresLoggedIn(App)

function ChromePopupApp(props: any) {
  return (
    <div style={{width: 320, height: 340}}>
      <Content />
    </div>
  )
}

export default ChromePopupApp
